"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureManager = /** @class */ (function () {
    function FeatureManager(list) {
        this.features = {};
        this.list = list;
    }
    FeatureManager.prototype.setFeatures = function (input) {
        var _this = this;
        if (!input)
            return;
        if (isPromise(input)) {
            input
                .then(function (rawFeatures) {
                _this.updateFeatures(rawFeatures);
            })
                .catch(function (err) {
                console.error(err);
            });
            return;
        }
        this.updateFeatures(input);
    };
    FeatureManager.prototype.isActive = function (featureName) {
        return Boolean(this.features[featureName]);
    };
    FeatureManager.prototype.isDisabled = function (featureName) {
        return !this.features[featureName];
    };
    FeatureManager.prototype.getFeatures = function () {
        // TODO: Optimize
        return __assign({}, this.features);
    };
    FeatureManager.prototype.updateFeatures = function (rawFeatures) {
        var _this = this;
        var supportedFeatureNames = Object.values(this.list);
        Object.keys(rawFeatures).forEach(function (featureName) {
            if (isSupportedFeature(supportedFeatureNames, featureName) &&
                isBooleanValue(rawFeatures[featureName], featureName)) {
                _this.features[featureName] =
                    rawFeatures[featureName];
            }
        });
    };
    return FeatureManager;
}());
function isSupportedFeature(supportedFeatureNames, featureName) {
    var isSupported = supportedFeatureNames.includes(featureName);
    if (!isSupported) {
        var formattedFeatureNames = supportedFeatureNames.map(function (name) { return "\n- \"" + name + "\""; });
        console.warn("[FeatureManager]: Unknown feature passed \"" + featureName + "\"\n\nSupported features: " + formattedFeatureNames);
    }
    return isSupported;
}
function isBooleanValue(value, featureName) {
    var isBoolean = typeof value === 'boolean';
    if (!isBoolean) {
        console.error("[FeatureManager]: Invalid value passed for feature: \"" + featureName + "\"! Expected boolean, but received: " + typeof value);
    }
    return isBoolean;
}
function isPromise(obj) {
    return (!!obj &&
        (typeof obj === 'object' || typeof obj === 'function') &&
        typeof obj.then === 'function');
}
exports.default = FeatureManager;
//# sourceMappingURL=FeatureManager.js.map